<template>
  <div class="wrapper">
    <van-notice-bar left-icon="volume-o" mode="closeable" wrapable :scrollable="false"
>当前页面的电票未获取到电子发票报销凭证，请线下发送邮件后，再标记已发</van-notice-bar>
    <div class="search">
      <div class="search-ipt">
        <div class="search-input">
          <input type="text" placeholder="搜索客户名称" v-model="searchParams.name">
        </div>
        <div class="search-icon" @click="onRefresh">
          搜索
        </div>
      </div>
      <div class="filter-option">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="searchOptions.drewDate"
            :options="drewDateOptions"
            @change="changeDrewDate"
          />
        </van-dropdown-menu>
        <p class="filter-btn" @click="openAllCard" v-if="!cardOpened">批量标记已发</p>
      </div>
    </div>
    <div class="pull-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell
            v-for="(invoice, index) in invoiceList"
            :key="index" :ref="'swipecell'+invoice.id"
            :name="invoice.id"
            :disabled="true"
            :before-close="beforeClose"
            :class="[!cardOpened ? 'swiper-cell-custom-wrp': ''].join(' ')"
          >
            <template #left>
              <div class="select-wrp" v-if="!invoice.select"><i class="iconfont select-font" v-tap="{methods: selectInvoice, params:{invoice}}">&#xe69c;</i></div>
              <div class="select-wrp" v-else-if="invoice.select"><i class="iconfont select-font-active" v-tap="{methods: cancelInvoice, params:{invoice}}">&#xe69d;</i></div>
            </template>
            <IncomeCard
              type="income"
              :invoice="invoice"
              :incomeParams="{remark: invoice.remark}"
              @incomeJump="gotoPage(invoice)"
            />
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="select-footer" v-if="this.cardOpened">
      <div class="wrp">
        <div class="select-wrp" v-if="selectCount === 0 || selectCount !== getCouldSelectedCount(invoiceList)"><i class="iconfont select-font" v-tap="{methods: selectAllInvoice, params:{}}">&#xe69c;</i></div>
        <div class="select-wrp" v-else-if="selectCount === getCouldSelectedCount(invoiceList)"><i class="iconfont select-font-active" v-tap="{methods: cancelAllInvoice, params:{}}">&#xe69d;</i></div>
        <div class="content">全选</div>
        <div class="content">已选择<span>{{selectCount}}张</span>发票</div>
      </div>
      <div class="btn-wrp">
        <van-button
          class="btn"
          round
          @click="openAllCard"
        >
          取消
        </van-button>
        <van-button
          class="btn"
          round
          @click="commitSelect"
        >
          标记已发
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { messageRequest } from '@services'
import IncomeCard from '@components/IncomeCard'
import moment from 'moment'
import {
  DropdownMenu,
  DropdownItem,
  List,
  PullRefresh,
  Notify,
  SwipeCell,
  Button,
  NoticeBar
} from 'vant'
export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [NoticeBar.name]: NoticeBar,
    IncomeCard
  },
  props: {},
  data () {
    return {
      drewDateOptions: [
        { text: '开票日期', value: undefined }
      ],
      searchParams: {
        size: 25,
        current: 1,
        name: '',
        logisticsStatus: 0, // 0 待寄送 1 待签收
        invoiceType: '08,10,14'
      },
      searchOptions: {
        drewDate: undefined
      },
      invoiceList: [],
      refreshing: false,
      loading: false,
      finished: false,
      cardOpened: false,
      selectCount: 0
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.initDrewDateOptions()
    this.getInvoiceList()
  },
  activated () {},
  updated () {},
  methods: {
    initDrewDateOptions () {
      let drewDateOptions = [
        { text: '开票日期', value: undefined }
      ]
      var data = new Date()
      // var year = data.getFullYear()
      data.setMonth(data.getMonth() + 1, 1) // 获取到当前月份,设置月份
      for (var i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        var m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let value = data.getFullYear() + '-' + (m)
        drewDateOptions.push({ text: value, value: value })
      }
      this.drewDateOptions = drewDateOptions
    },
    async getInvoiceList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const postData = {
        ...this.searchParams
      }
      const data = await messageRequest.todo.getTicketPageByIds(postData)
      if (data.success) {
        if (data.result.records) {
          this.invoiceList = [...this.invoiceList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        Notify({ type: 'danger', message: data.message })
      }

      this.loading = false
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.cardOpened = false
      this.selectCount = 0
      this.invoiceList = []
      this.getInvoiceList()
    },
    onLoad () {
      this.searchParams.current++
      this.getInvoiceList()
    },
    changeDrewDate (value) {
      if (value) {
        this.searchParams.startTime = moment(value).startOf('month').format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.endTime = moment(value).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      }
      this.onRefresh()
    },
    selectInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = true
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    cancelInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = false
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    selectAllInvoice (data) {
      this.invoiceList.forEach(v => {
        v.select = true
      })
      this.selectCount = this.getCouldSelectedCount(this.invoiceList)
    },
    getCouldSelectedCount (list) {
      return list.length
    },
    cancelAllInvoice (data) {
      this.invoiceList.forEach(v => {
        v.select = false
      })
      this.selectCount = 0
    },
    openAllCard () {
      if (this.cardOpened) {
        this.cardOpened = false
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('swipecell')) {
            this.$refs[key][0] && this.$refs[key][0].close('left')
          }
        })
      } else {
        this.cardOpened = true
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('swipecell')) {
            this.$refs[key][0] && this.$refs[key][0].open('left')
          }
        })
      }
    },
    async commitSelect () {
      if (this.selectCount === 0) {
        Notify({ type: 'danger', message: '请选择数据' })
        return
      }
      let ids = []
      this.invoiceList.forEach(v => {
        if (v.select) {
          ids.push(v.id)
        }
      })
      let params = {
        ticketIdList: ids
      }
      const data = await messageRequest.todo.markSend(params)
      if (data.success) {
        this.onRefresh()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    beforeClose ({ position, instance }) {
      switch (position) {
        case 'left':
          break
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
